import { Component, Fragment, Prop, h } from '@stencil/core';

@Component({
  tag: 'input-rounded-button',
  styleUrl: 'input-rounded-button.css',
})
export class InputRoundedButton {
  // buttonId is required for click function to work properly. Cannot be an empty string.
  @Prop() buttonId!: string;
  @Prop() caption: string = '';
  @Prop() hasError: boolean = false;
  @Prop() isDisabled: boolean = false;
  @Prop() label: string = '';
  @Prop() name: string = '';
  @Prop({ mutable: true }) selected: boolean = false;
  @Prop() whenClicked: (buttonId: string) => void = () => {};
  @Prop() isLocked: boolean = false;

  onChange(value) {
    if (this.isLocked) {
      return;
    }

    this.selected = true;
    this.whenClicked(value);
  }

  render() {
    const hasCaption = typeof this.caption === 'string' && this.caption.length > 0;
    const isUnselectedEnabled = !this.selected && !this.isDisabled;
    const isSelectedEnabled = this.selected && !this.isDisabled;
    const isUnselectedDisabled = !this.selected && this.isDisabled;
    const isSelectedDisabled = this.selected && this.isDisabled;
    const isUnselectedLocked = !this.selected && this.isLocked;
    const isSelectedLocked = this.selected && this.isLocked;

    const containerClass = {
      'input-rounded-button__container': true,
      'input-rounded-button__container--unselected-enabled': isUnselectedEnabled,
      'input-rounded-button__container--selected-enabled': isSelectedEnabled,
      'input-rounded-button__container--unselected-disabled': isUnselectedDisabled,
      'input-rounded-button__container--selected-disabled': isSelectedDisabled,
      'input-rounded-button__container--unselected-locked': isUnselectedLocked,
      'input-rounded-button__container--selected-locked': isSelectedLocked,
      'input-rounded-button__container--with-caption': hasCaption,
      'input-rounded-button__container--error': this.hasError,
    };
    const labelWrapperClass = {
      'input-rounded-button__label-wrapper': true,
      'input-rounded-button__label-wrapper--disabled': this.isDisabled,
    };

    const overlayClass = {
      'input-rounded-button__overlay': true,
      'input-rounded-button__overlay--enabled': !this.isDisabled,
    };

    const radioButtonClass = {
      'input-rounded-button__radio': true,
      'input-rounded-button__radio--selected': this.selected,
      'input-rounded-button__radio--disabled': this.isDisabled,
    };

    return (
      <label class="group input-rounded-button" htmlFor={this.buttonId} data-testId="input-rounded-button">
        <div class={containerClass}>
          <input
            checked={this.selected}
            class="peer hidden"
            disabled={this.isDisabled}
            id={this.buttonId}
            name={this.name}
            type="radio"
            onClick={() => {
              this.onChange(this.buttonId);
            }}
          />
          <div class="relative mr-3">
            {this.isLocked && this.selected ? (
              <icon-lock class="input-rounded-button__lock-icon" />
            ) : (
              !this.isLocked && (
                <Fragment>
                  <div class={radioButtonClass} />
                  <div class={overlayClass} />
                </Fragment>
              )
            )}
          </div>
          <div class={labelWrapperClass}>
            <div>{this.label}</div>
            {hasCaption && <div class="text-caption">{this.caption}</div>}
          </div>
        </div>
      </label>
    );
  }
}
